module.exports = __webpack_public_path__ + "img/flat-unlock-button-lincoln.7b3a4040.png";